import {
  CardNotice,
  ChatCard,
} from '@euler/app/flows/ai-suite/components/ChatCard';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { memo } from 'react';
import { BiDraftPendingCard } from './BiDraftPendingCard';
import { BiVisualizationBody } from './BiVisualizationBody';
import { DraftPlacement } from './DraftPlacement';
import { biCardSubtitle } from './functions/biCardSubtitle';
import { biVizIcon } from './functions/biVizIcon';
import { useBiDraft } from './functions/useBiDraft';
import { useBiViewMode } from './functions/useBiViewMode';

const kDefaultTitle = '数据图表';

export const BiDraftCard = memo(
  ({ draftId, title }: { draftId: string; title?: string }) => {
    const state = useBiDraft(draftId);
    const ready = state.kind === 'ready' ? state.draft : null;
    const { view, toggle } = useBiViewMode(
      ready?.viz ?? null,
      ready?.result.current ?? null,
    );
    if (state.kind !== 'ready')
      return (
        <BiDraftPendingCard state={state} title={title ?? kDefaultTitle} />
      );
    const { draft } = state;
    const { current } = draft.result;
    return (
      <ChatCard
        icon={biVizIcon(draft.viz.type)}
        color={aiColors.amber}
        title={title ?? draft.title}
        subtitle={biCardSubtitle(draft.viz, current)}
        badge={toggle}
      >
        <BiVisualizationBody
          viz={draft.viz}
          result={draft.result}
          view={view}
        />
        {current.truncated ? (
          <CardNotice text="符合条件的数据超过上限，这里只包含部分结果。" />
        ) : null}
        <DraftPlacement draft={draft} />
      </ChatCard>
    );
  },
);
